import { getAssetsUrl } from "@gik/core/utils/LinkUtils";

const groupImagesDir = `${getAssetsUrl()}inkind-page/img/group/`;

export const iconImageUrl = `${groupImagesDir}group-icon-placeholder.svg`;
export const logoImageUrl = `${groupImagesDir}group-logo-placeholder.svg`;
